import React from 'react';
import Avatar from '../atoms/Avatar';
import Typography from '../atoms/Typography';
import Button from '../atoms/Button';
import VoiceSettings from './VoiceSettings';
import './ChatHeader.css';

const ChatHeader = ({
  name,
  status,
  avatarSrc,
  onBackClick,
  vocabularyOpen = false,
  onToggleVocabulary,
  missionsOpen = false,
  onToggleMissions,
  larpOpen = false,
  onToggleLarp,
}) => {
  return (
    <div className="chat-header">
      <div className="chat-header-left">
        <Button 
          type="button"
          className="chat-header-back"
          onClick={onBackClick}
          variant="outline"
          size="small"
        >
          ←
        </Button>
        <Avatar src={avatarSrc} alt={name} status={status} />
        <div className="chat-header-info">
          <Typography variant="subtitle1">{name}</Typography>
          <Typography variant="caption" color="light" className="chat-header-status">
            {status === 'online' ? 'Online' : 
             status === 'away' ? 'Away' : 
             status === 'busy' ? 'Do not disturb' : 'Offline'}
          </Typography>
        </div>
      </div>
      <div className="chat-header-actions">
        {onToggleLarp && (
          <button
            type="button"
            className={`larp-toggle ${larpOpen ? 'active' : ''}`}
            aria-expanded={larpOpen}
            aria-controls="larp-options"
            onClick={onToggleLarp}
          >
            LARP
          </button>
        )}
        {onToggleMissions && (
          <button
            type="button"
            className={`missions-toggle ${missionsOpen ? 'active' : ''}`}
            aria-expanded={missionsOpen}
            aria-controls="missions-modal"
            onClick={onToggleMissions}
          >
            Missions
          </button>
        )}
        {onToggleVocabulary && (
          <button
            type="button"
            className={`phrases-toggle ${vocabularyOpen ? 'active' : ''}`}
            aria-pressed={vocabularyOpen}
            onClick={onToggleVocabulary}
          >
            Phrases
          </button>
        )}
        <VoiceSettings className="header-voice-settings" />
      </div>
    </div>
  );
};

export default ChatHeader;
